import React, { useRef, useEffect, useMemo, useState } from "react"
import { PrizeContainer } from "../PrizeComponents"
import TiptapEditor from "../TiptapEditor"
import Style from "./style"

const PrizeAutoScroll = ({ prize_editor = [], speed = 1 }) => {
  const scrollRef = useRef(null)
  const contentRef = useRef(null)

  const [shouldScroll, setShouldScroll] = useState(false)
  const [isVisible, setIsVisible] = useState(false)

  const mergedHtml = useMemo(() => {
    return (prize_editor || []).join("")
  }, [prize_editor])

  useEffect(() => {
    const container = scrollRef.current
    if (!container) return

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries
        setIsVisible(entry.isIntersecting)
      },
      { threshold: 0.1 }
    )

    observer.observe(container)

    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    const container = scrollRef.current
    const content = contentRef.current
    if (!container || !content || !isVisible) return

    let interval

    const checkScrollNeed = () => {
      const firstChild = content.firstElementChild
      if (firstChild) {
        const containerHeight = container.clientHeight
        const actualContentHeight = firstChild.scrollHeight
        const needsScroll = actualContentHeight > containerHeight
        
        setShouldScroll(needsScroll)
        
        return needsScroll
      }
      return false
    }

    const scroll = () => {
      if (!container || !content) return
      
      container.scrollTop += 1
      
      const maxScroll = content.scrollHeight / 2
      if (container.scrollTop >= maxScroll) {
        container.scrollTop = 0
      }
    }
      
    const timeoutId = setTimeout(() => {
      const needsScroll = checkScrollNeed()
      if (needsScroll) {
        const intervalDelay = Math.max(10, Math.round(1000 / (speed * 10)))
        
        interval = setInterval(scroll, intervalDelay)
      }
    }, 200)

    return () => {
      clearTimeout(timeoutId)
      if (interval) {
        clearInterval(interval)
      }
    }

  }, [mergedHtml, speed, isVisible])

  return (
    <Style.ScrollContainer ref={scrollRef}>
      <div ref={contentRef}>
        <PrizeContainer>
          <TiptapEditor
            key={mergedHtml}
            initialContent={mergedHtml}
            editable={false}
          />
        </PrizeContainer>
        
        {shouldScroll && (
          <PrizeContainer>
            <TiptapEditor
              key={`${mergedHtml}-clone`}
              initialContent={mergedHtml}
              editable={false}
            />
          </PrizeContainer>
        )}
      </div>
    </Style.ScrollContainer>
  )
}

export default PrizeAutoScroll